
import { defineComponent, reactive, ref, Ref } from "vue";
import { RequestKindTypes } from "@/models/request";
import RequestView from "@/components/common/Request/RequestView.vue";
import CancelConfirm from "@/components/common/Confirm/CancelConfirm";
import router from "@/router";
import { RouterName } from "@/models/common";

export default defineComponent({
  name: "Second Opinion Request View",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const state = reactive({
      id: props.id,
    });

    const cancel$: Ref<CancelConfirm | null> = ref(null);

    const CancelRequest = (requestKey: number) => {
      console.log(cancel$.value);
      cancel$.value?.cancelConfirm(requestKey);
    };

    const CancelAccept = () => router.push(RouterName.SECOND_OPINION);

    return { state, RequestKindTypes, CancelRequest, CancelAccept, cancel$ };
  },
  components: {
    RequestView,
  },
});
